import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import GroupTitleBar from 'notebook/notes/groups/GroupTitleBar';
import {NoteLinkedGroupKind} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import groupKindToIcon from 'notebook/notes/groups/util/groupKindToIcon';

export interface NotePartGridHeaderProps {
  groupName: string;
  rightHeaderControls?: JSX.Element | null;
  isCollapsed: boolean;
  onToggleCollapsed: () => void;
  viewer?: boolean;
}

/**
 * Header for a NotePartGrid note part. Renders the shared GroupTitleBar so
 * NotePartGrid gets the same name/icon/collapse affordances as other
 * NoteLinkedGroup kinds.
 *
 * TODO(BNCH-153542): Re-evaluate the NoteLinkedGroupView/Adapter encapsulation.
 * NotePartGrid and StoichiometryGroup both bypass NoteLinkedGroupView in favor
 * of their own view components, indicating the adapter pattern doesn't model
 * the right level of shared behavior. Consider renaming NoteLinkedGroupView to
 * MixtureView and extracting a common view-layer abstraction that all
 * NoteLinkedGroup kinds can extend.
 */
export default function NotePartGridHeader({
  groupName,
  rightHeaderControls,
  isCollapsed,
  onToggleCollapsed,
  viewer,
}: NotePartGridHeaderProps): JSX.Element {
  return (
    <div {...getTestProps({component: 'NotePartGrid', element: 'header'})}>
      <GroupTitleBar
        groupName={groupName}
        icon={groupKindToIcon(NoteLinkedGroupKind.NOTE_PART_GRID)}
        rightHeaderControls={rightHeaderControls}
        isCollapsed={isCollapsed}
        onToggleCollapsed={onToggleCollapsed}
        viewer={viewer}
      />
    </div>
  );
}
